import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router-dom";

import { Edit } from "./pages/edit";
import { Start } from "./pages/start";
import { View } from "./pages/view";

export function App() {
  const queryClient = new QueryClient();

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route element={<Start />} path="/" />
            <Route element={<View />} path="/:code" />
            <Route element={<Edit />} path="/:code/edit" />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
